import SiteFooter from "../components/SiteFooter";
import PublicPageHeader from "../components/PublicPageHeader";

const faqs = [
  {
    q: "What is MoolTax?",
    a: "MoolTax is a digital tax filing support platform that helps you submit tax-related details, upload documents securely, track your filing progress, and communicate with assigned tax professionals.",
  },
  {
    q: "Who can use MoolTax?",
    a: "Salaried individuals, freelancers, consultants, and business owners can use MoolTax. We offer separate plans for salaried professionals and business owners based on their filing needs.",
  },
  {
    q: "How does the process work?",
    a: "Create an account, verify your email, choose a plan, complete payment, upload your documents, and track your case progress from the dashboard. Our team reviews your documents and coordinates the filing.",
  },
  {
    q: "What documents do I need?",
    a: "Documents depend on your selected plan and tax situation. Common documents include PAN card, Aadhaar, Form 16, bank statements, investment proofs, and rent receipts. The platform will guide you on what is required for your specific plan.",
  },
  {
    q: "When do I pay?",
    a: "Payment is required after selecting your plan and before uploading documents. Pricing is displayed clearly before you confirm your selection.",
  },
  {
    q: "Is my data secure?",
    a: "Yes. All uploaded documents are stored on secured cloud storage with access controls. Data is transmitted over HTTPS. We do not share your documents with any third party except as required for the filing process.",
  },
  {
    q: "Can I start without all documents?",
    a: "You can begin after payment and upload documents progressively. If additional documents are needed, our team will communicate through the platform.",
  },
  {
    q: "What is your refund policy?",
    a: "Refunds may be available if requested within 48 hours of payment and before any review work has started. Once case review begins, fees are non-refundable. See our full Refund Policy for details.",
  },
  {
    q: "How long does filing take?",
    a: "Timelines depend on the completeness of your documents and the complexity of your case. Most cases are processed within a few business days of receiving complete documents.",
  },
  {
    q: "How can I contact support?",
    a: "You can reach us at support@mooltax.com or through the Contact Us page. We aim to respond within 24–48 business hours.",
  },
];

const FaqPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--secondary)" }}>
      <PublicPageHeader />
      <main className="px-6 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl border p-8 md:p-10" style={{ borderColor: "var(--border)" }}>
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}>
            Frequently Asked Questions
          </h1>
          <p className="text-sm opacity-60 mb-8">
            Can't find your answer? Email us at{" "}
            <a href="mailto:support@mooltax.com" className="underline">support@mooltax.com</a>
          </p>

          <div className="space-y-4">
            {faqs.map((item, idx) => (
              <div key={idx} className="border rounded-xl p-5" style={{ borderColor: "var(--border)" }}>
                <h2 className="text-base font-semibold mb-2">{item.q}</h2>
                <p className="text-[15px] leading-7 opacity-80">{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default FaqPage;
